import { gql } from "@apollo/client";

const GETDASHBOARDUSERDATA = gql`
  query getDashboardUsers(
    $paneltype: String
    $mainSuperAdminId: ID
    $agentId: ID
    $query: String
    $subscriptionAgentId: ID
    $cursor: Int
    $limit: Int
  ) {
    getDashboardUsers(
      paneltype: $paneltype
      mainSuperAdminId: $mainSuperAdminId
      agentId: $agentId
      query: $query
      subscriptionAgentId: $subscriptionAgentId
      cursor: $cursor
      limit: $limit
    ) {
      success
      error
      count
      hasNextPage
      data {
        loggedIn
        isOnline
        isConnected
        agentId
        username
        picture
        mainSuperAdminId
        managerId
      }
    }
  }
`;

export default GETDASHBOARDUSERDATA;
